import Scroller from "../util/scroller";
import Rating from "../components/rating";

export default {
    init() {
        function callback() {
            this.classList.add("is-visible");
        }

        var related_products = new Scroller(document.querySelector(".product-list"), {
            callback: callback,
            triggerOffset: -250
        });

        var rating = new Rating();
    },
    finalize() {

    }
};



// WEBPACK FOOTER //
// ./js/routes/single-recipes.js